/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
import React, { useState, useEffect, Fragment } from 'react';
import {
  Box, Modal, styled, FormGroup, Typography, Switch, Radio, Stack, TextField, List,
  ListItem, ListItemText, Grid, Button, Tooltip
} from '@mui/material';
import { Rnd } from 'react-rnd';
import { TabContext, TabPanel } from '@mui/lab';
import { closeIconBlack } from '../../shared/assets/images';
import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';

import './specifyFlow.scss';

import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { convertUnitValues_flow } from '../../shared/conversion-helper/unitConversion';

const SpecifyFlow = (props) => {
  const {
    visibleSpecifyFlow,
    elements,
    openModelPopUp,
    handleCloseSpecifyFlow,
    disabledStripperAndExplorerTab,
    translateObject
  } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [activeTab] = useState('1');
  const [feedCount, setFeedCount] = useState([]);
  const [productCount, setProductCount] = useState([]);
  const [feedFlowValue, setFeedFlowValue] = useState({});
  const [productFlowValue, setProductFlowValue] = useState({});
  const [checked, setChecked] = React.useState(false); // only select product flow --> krnathi
  const [selectedValue_radio, setSelectedValue_radio] = React.useState(true);
  const [selectedText, setSelectedText] = React.useState(translateObject('Enter any one input field')); // changed selected text -->Kranthi
  const units = JSON.parse(localStorage.getItem('system-units')) || {};
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);

  useEffect(() => {
    const feedFlowArray = [];
    const productFlowArray = [];
    const feedFlow = {};
    const productFlow = {};
    elements.forEach((ele) => {
      if (ele.id.length < 20) {
        if (ele.id.includes('feed')) {
          feedFlowArray.push(localStorage.getItem(ele.id));
          setFeedCount([...feedFlowArray]);
          feedFlow[localStorage.getItem(ele.id)] = '';
          setFeedFlowValue({ ...feedFlow });
        }
        else if (ele.id.includes('roPump') || ele.id.includes('cf') || ele.id.includes('edi') ||
          ele.id.includes('cls') || ele.id.includes('product')) {
          productFlowArray.push(localStorage.getItem(ele.id));
          setProductCount([...productFlowArray]);
          productFlow[localStorage.getItem(ele.id)] = '';
          setProductFlowValue({ ...productFlow });
          setSelectedValue_radio(productFlowArray[0]);
        }
      }
      const getseletedValue = JSON.parse(localStorage.getItem('product_flow_dict'));
      if (getseletedValue && getseletedValue.product_flow) {
        setChecked(getseletedValue.product_flow.product_value.product_flow_selected);
        setSelectedValue_radio(getseletedValue.product_flow.product_value.selected_radio_value);

        if (getseletedValue.product_flow.product_value.product_flow_selected)
          setSelectedText(translateObject('Enter all input fields'));
        else
          setSelectedText(translateObject('Enter any one input field'));

        if (productFlowArray.indexOf(getseletedValue.product_flow.product_value.selected_radio_value) === -1) {
          setSelectedValue_radio(productFlowArray[0]);
        }
      }
      else if (checked)
        setSelectedText(translateObject('Enter all input fields'));
      else
        setSelectedText(translateObject('Enter any one input field'));
    });

    const feedValue_dict = JSON.parse(localStorage.getItem('feed_flow_dict'));
    const feedflow_updated = {};
    if (feedValue_dict && Object.keys(feedValue_dict).length > 0) {
      feedFlowArray.forEach((item) => {
        if (feedValue_dict.feed_flow.feed_value[item] > 0) {
          const val = Number(feedValue_dict.feed_flow.feed_value[item]);
          feedflow_updated[item] = val;
        }
        else {
          feedflow_updated[item] = '';
        }
      });
      setFeedFlowValue(feedflow_updated);
    }

    const productValue_dict = JSON.parse(localStorage.getItem('product_flow_dict'));
    const productflow_updated = {};
    if (productValue_dict && Object.keys(productValue_dict).length > 0) {
      productFlowArray.forEach((item) => {
        if (productValue_dict.product_flow.product_value[item] > 0) {
          const val = Number(productValue_dict.product_flow.product_value[item]);
          productflow_updated[item] = val;
        }
        else {
          productflow_updated[item] = '';
        }
      });
      setProductFlowValue(productflow_updated);
    }
    // added by Akhil on 1st April24 that if there are more than 1 feed unitop present then we have to switch
    // to feed flow option irrespective of product flow unitops.
    if (feedFlowArray.length > 1) {
      setChecked(true);
    }
  }, [elements]);

  function getUnitValue(value) {
    return units.flow || value;
  }

  const handleChange_radio = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    setSelectedValue_radio(e.target.value);
    for (const k in productFlowValue) {
      if (k !== e.target.value) {
        productFlowValue[k] = '';
      }
    }
  };

  const handleChange = (event) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    setChecked(event.target.checked);
    if (event.target.checked === true)
      setSelectedText(translateObject('Enter all input fields'));
    else
      setSelectedText(translateObject('Enter any one input field'));
    const feedFlowArray = [];
    const productFlowArray = [];
    elements.forEach((ele) => {
      if (ele.id.length < 20) {
        if (ele.id.includes('feed')) {
          feedFlowArray.push(localStorage.getItem(ele.id));
          setFeedCount([...feedFlowArray]);
        } else if (ele.id.includes('roPump') || ele.id.includes('cf') ||
          ele.id.includes('edi') || ele.id.includes('cls') || ele.id.includes('product')) {
          productFlowArray.push(localStorage.getItem(ele.id));
          setProductCount([...productFlowArray]);
        }
      }
    });

    const productValue_dict = JSON.parse(localStorage.getItem('product_flow_dict'));
    const productflow_updated = {};
    if (productValue_dict) {
      productFlowArray.forEach((item) => {
        if (productValue_dict.product_flow.product_value[item] > 0) {
          const val = Number(productValue_dict.product_flow.product_value[item]);
          productflow_updated[item] = val;
        }
        else {
          productflow_updated[item] = '';
        }
      });
      setProductFlowValue(productflow_updated);
    }

    if (feedFlowArray.length > 1) {
      openModelPopUp(
        'Winflows Design Simulator detects multiple feed sources on the current flowsheet. Please input the flow rate for the respective feed source.',
        'Warning', 'warning'
      );
      setChecked(true);
    }
  };
  const handleNumberChange = (e, obj) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    const { value } = e.target;

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const val = localStorage[key];
      if (val === obj) {
        if (key.includes('feed')) {
          setFeedFlowValue({ ...feedFlowValue, [obj]: value }); // reomved Number formate for GB-2378 issue by kranthi
        }
        if (['roPump', 'cf', 'edi', 'ro', 'product', 'cls'].includes(key.split('_')[0])) {
          setProductFlowValue({ ...productFlowValue, [obj]: value }); // reomved Number formate for GB-2378 issue by kranthi
        }
      }
    }
    disabledStripperAndExplorerTab();
  };

  const handleCloseSpecify_Flow = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    handleCloseSpecifyFlow();
  };

  const handleCloseSpecifyFlowModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleCloseSpecify_Flow(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleCloseSpecifyFlow();
    };
  };

  const handleUpdate = () => {
    let flag = true;
    if (checked === true) {
      Object.keys(feedFlowValue).forEach((key) => {
        if (Number(feedFlowValue[key]) === 0) {
          flag = false;
          openModelPopUp(
            'Enter all input field values!', 'Warning', 'warning'
          );

        }
      });
    }

    if (checked === true) {
      const productFlowValue_temp = {};
      const feedFlowValue_conv = {};

      Object.keys(feedFlowValue).forEach((key) => {
        feedFlowValue_conv[key] = Number((parseFloat(convertUnitValues_flow(feedFlowValue[key], getUnitValue('gpm'),
          'm3/s'))).toFixed(10));
      });

      Object.keys(productFlowValue).forEach((key) => {
        productFlowValue_temp[key] = 0.0;
      });
      const flow_dict = { ...feedFlowValue_conv, ...productFlowValue_temp, 'feed_flow_flag': checked };
      localStorage.setItem('flow_dict', JSON.stringify(flow_dict));
    }
    else {

      const feedFlowValue_temp = {};
      const productFlowValue_conv = {};

      Object.keys(feedFlowValue).forEach((key) => {
        feedFlowValue_temp[key] = 0.0;
      });
      Object.keys(productFlowValue).forEach((key) => {
        productFlowValue_conv[key] = Number((parseFloat(convertUnitValues_flow(productFlowValue[key], getUnitValue('gpm'),
          'm3/s'))).toFixed(10));
      });
      const flow_dict = { ...feedFlowValue_temp, ...productFlowValue_conv, 'feed_flow_flag': checked };
      localStorage.setItem('flow_dict', JSON.stringify(flow_dict));
    }

    saveFormDataInLocalStorage({ record: feedFlowValue, type: 'feed_flow', id: 'feed_value', item: 'feed_flow_dict' });
    saveFormDataInLocalStorage({
      record: {
        ...productFlowValue,
        'product_flow_selected': checked,
        'selected_radio_value': selectedValue_radio
      }, type: 'product_flow', id: 'product_value', item: 'product_flow_dict'
    });

    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    if (flag)
      handleCloseSpecifyFlow();

  };

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? 'rgb(0,174,199)' : 'rgb(0,174,199)',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 500,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? 'rgb(0,174,199)' : 'rgb(0,174,199)',
      boxSizing: 'border-box',
    },
  }));

  return (
    <Modal
      hideBackdrop
      open={visibleSpecifyFlow}
      onClose={handleCloseSpecifyFlowModal}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="mixsplitter-modal"
    >
      <Box>
        <Rnd
          default={{
            x: ((window.innerWidth / 2) - (500 / 2)),
            y: ((window.innerHeight / 2) - (261 / 2)),
            width: 500,
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth={400}
          cancel='.no_drag'
          className='split-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='split-grid-container'>
            <Grid item xs={12} className='split-header-grid'>
              <div className='split-header-text rufusBld no_drag forground-text-primary S_heading'>{translateObject('Specify Flow')}</div>
              <div className='split-close-icon no_drag'>
                <Tooltip title="Close">
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={handleCloseSpecifyFlowModal}
                    style={{ display: 'block' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='split-body-container'>
              <Box sx={{ width: '100%', typography: 'body1', 'maxHeight': '67%' }} className='mixer-box-container'>
                <TabContext value={activeTab}>
                  <TabPanel value='1' className='splitter-mixer-container'>
                    <div>
                      <div className='col-2 rufusReg stream-number no_drag'>
                        <FormGroup>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Typography style={{
                              'fontWeight': checked ? 400 : 600, color: checked ? '#1C1C1F' : '#002D62'
                            }}>{translateObject('Product flow')}</Typography>
                            <AntSwitch
                              inputProps={{ 'aria-label': 'ant design' }}
                              checked={checked}
                              onChange={handleChange}
                            />
                            <Typography style={{ 'fontWeight': !checked ? 400 : 600, color: !checked ? '#1C1C1F' : '#002D62' }}>Feed flow</Typography>
                          </Stack>
                        </FormGroup>
                      </div>
                    </div>
                    <div className='anyone-field no_drag'>{selectedText}</div>
                    <List component="nav" aria-label="mailbox folders" className={`outlet-streams ${!checked ? 'stream-true' : ''}`}>
                      {checked === true ? (feedCount || []).map((obj, i) => (
                        <Fragment key={i}>
                          <ListItem className='list-item-input no_drag'>
                            <ListItemText className='col-2 sansW4SeLig ' style={{ 'position': 'relative' }}>
                              <div className='no-drag FlowText'>{obj}</div>
                              <div className='Inputspan-2'>
                                <TextField
                                  className="input-data"
                                  id="filled-hidden-label-small"
                                  variant="outlined"
                                  type="number"
                                  value={(feedFlowValue[obj] !== 'undefined') ? feedFlowValue[obj] : ''}
                                  onFocus={e => e.target.select()}
                                  onChange={(e) => handleNumberChange(e, obj)}
                                  sx={{ width: 85, '& fieldset': { borderRadius: '22px' } }}
                                />
                                <div className='no-drag'>{getUnitValue('gpm')}</div>
                              </div>
                            </ListItemText>
                          </ListItem>
                        </Fragment>
                      )) :
                        (productCount || []).map((obj, i) => (
                          <Fragment key={i}>
                            <ListItem className='list-item-input no_drag'>
                              <ListItemText className='col-2 sansW4SeLig' style={{ 'position': 'relative' }}>
                                <div style={{ 'display': 'flex', 'alignItems': 'center' }}>
                                  <Radio
                                    checked={selectedValue_radio === obj}
                                    onChange={handleChange_radio}
                                    value={obj}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'B' }}
                                  />
                                  <div className='no-drag FlowText'>{obj}</div>
                                </div>
                                <div className={`Inputspan-2 ${!checked ? 'active-disabled' : ''}`} id={obj}>
                                  <TextField
                                    id="filled-hidden-label-small"
                                    variant="outlined"
                                    type="number"
                                    disabled={selectedValue_radio !== obj}
                                    className={`input-data ${selectedValue_radio !== obj ? 'input-disabled' : ''}`}
                                    value={(productFlowValue[obj] !== 'undefined') ? productFlowValue[obj] : ''}
                                    onFocus={e => e.target.select()}
                                    onChange={(e) => handleNumberChange(e, obj)}
                                    sx={{ width: 85, '& fieldset': { borderRadius: '22px' } }}
                                  />
                                  <div className='no-drag'>{getUnitValue('gpm')}</div>
                                </div>
                              </ListItemText>
                            </ListItem>
                          </Fragment>
                        ))}
                    </List>
                    <div className="split-button">
                      <Stack spacing={3} direction="row">
                        <Button variant="contained" className="sansW4SeLig Primary_Default_Button"
                          style={{ width: '8vw' }}
                          size="small" onClick={handleUpdate}> {translateObject('OK')} </Button>
                      </Stack>
                    </div>
                  </TabPanel>
                </TabContext>
              </Box>
            </Grid>
          </Grid>
        </Rnd>
      </Box >
    </Modal >
  );
};
export default SpecifyFlow;